
<div class="white">
    <div
        v-for = "(entry, index) in menu"
        :key  = "index"
    >
        <a @click = "onMenu(entry)">
            <div style="height: 22px;" class="v-flex">
                <v-icon
                    size   = "18"
                    :color = "entry.available ? 'black' : 'secondary'"
                >
                    {{ entry.icon }}
                </v-icon>

                <div style="font-size: 13px;padding-left: 4px; margin-top: 2px; width: 100px">
                    {{ entry.name }}
                </div>

                <div
                    v-if   = "entry.available"
                    class  = "menu-status"
                >
                    <v-icon size="20" :color="statusColor (entry.status)">{{ statusIcon (entry.status) }}</v-icon>
                </div>
            </div>
        </a>
    </div>
</div>
